<template>
  <div>
    <div class="card modal-card-border infoWindowMap">
      <div class="card-content">
        <div class="columns">
          <div class="column is-9">
            <h1 class="is-5">
              <span class="subtitle">
                Emplacement
              </span>
              <span class="title is-5">{{panneau.namePlace}}</span>
            </h1>
            <p class="subtitle is-7" v-if="panneau.extensionOpportunite.faceSelectionneCode">
              Face(s) : {{panneau.extensionOpportunite.faceSelectionneCode}}
            </p>
          </div>
        </div>
        <div class="columns detail-component">
          <div class="column is-5">
            <img :src="panneau.urlPhoto"
                v-if="panneau.urlPhoto"
                style="max-height:220px">
            <img v-else src="@/assets/default-placeholder.png">
            <br/>
          </div>
          <div class="column is-8">
            <h1 class="subtitle is-6 information-title">Informations</h1>
            <div class="columns">
              <div class="column is-6">
                <p class="information">Adresse commerciale</p>
                <span>{{panneau.adresse1}}</span>
                <span v-if="panneau.adresse2">{{panneau.adresse2}} </span>
                <span v-if="panneau.adresse3">{{panneau.adresse3}} </span>
                <span>{{panneau.ville}}</span>
                <br>
                <p class="information">Format</p>
                <span>{{panneau.format}}</span>
                <br>
                <p class="information">Matériel</p>
                <span>{{panneau.materiel}}</span>
                <br>
              </div>
              <div class="column is-6">
                <p class="information">En venant de</p>
                <span>{{panneau.enVenantDe}}</span>
                <br>
                <p class="information">En allant vers</p>
                <span>{{panneau.enAllantVers}}</span>
                <br>
                <p class="information">Eclairé</p>
                <span>{{panneau.eclaire ? 'Oui' : 'Non'}}</span>
                <br>
                <p class="information">Nombre de propositions :</p>
                <span>{{panneau.nbPropositions}}</span>
              </div>
            </div>
          </div>
          <div class="column is-4">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'info-window-produit',
  props: ['panneau'],
  data() {
    return {};
  },
};

</script>

<style scoped>
.distance{
  margin-left: 0px;
  margin-top: -33px;
}

.columns{
  margin:0px;
}

  .information {
    font-size:14px;
  }

  .information-title {
    margin-left:10px;
    margin-bottom:0;
  }

.arrow {
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/composantsProduits/infoWindowProduit.vue